import { Environment } from "./environment";

export async function getEnvironment<T extends Environment>(): Promise<T> {
    const response = await fetch("/environment-settings");

    if (response.ok) {

        var responseObj = await response.json();
        return <T>responseObj;
    }
}
